import React from "react";
import NavBarMain from "./NavBarMain";
import Table from "react-bootstrap/Table";
import { useEffect } from "react";
import axios from ".././axios-interceptor";
import { useState } from "react";
import NewServiceRequest from "./NewServiceRequest";

import {
  base_url,
  STATUS_NEW,
  STATUS_IN_PROGRESS,
  STATUS_APPROVED,
  STATUS_REJECTED,
  STATUS_PROCESSED,
  SERVICE_REQUEST_NEW_LOAN,
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
  STATUS_CLOSED,
  SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
  STATUS_PENDING_INVESTOR,
} from "./../utilities";
import SideNavBar from "./SideNavBar";
import Skeleton from "react-loading-skeleton";
import ServiceRequestsDetails from "./MyServiceRequestDetails";
import ServiceRequestsTerms from "./BusinessLoanTerms";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import Cookies from 'js-cookie';
const MyServiceRequests = (props) => {
  const navigate = useNavigate();
 
  useEffect(() => {
    if (!Cookies.get("User_Accesstoken_Business")) {
      navigate("/");
    }
  }, []);

  const [firstValue, setFirstValue] = useState([]);
  const [secondValue, setSecondValue] = useState([]);
  const [thirdValue, setThirdValue] = useState([]);
  const [fourthValue, setFourthValue] = useState([]);
  let ltwo = props.loading;
  const [show, setShow] = React.useState(false);
  const [businessdataUser, setBusinessdataUser] = useState([]);
  const [servicedata, setServiceData] = useState([]);
  const [servicedatafilter, setServiceDataFilter] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .post(base_url + "business-master/get_business_data_user", {
        user_id: Cookies.get("user_id"),
      })
      .then((res) => {
        setBusinessdataUser(res.data.data[0]);
      })
      .catch((err) => {
        if (err.response.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Business");
          Cookies.remove("User_Refreshtoken_Business");
          navigate("/");
        }
      });
    axios
      .post(base_url + "service-request-trx/get_service_request_user", {
        user_id: Cookies.get("user_id"),
      })
      .then((res) => {
        res.data.data.forEach((elem) => {
          if (elem.status == STATUS_NEW) {
            elem.status = "New";
          }
          if (elem.status == STATUS_CLOSED) {
            elem.status = "Closed";
          }
          if (elem.status == STATUS_IN_PROGRESS) {
            elem.status = "In Progress";
          }
          if (elem.status == STATUS_PROCESSED) {
            elem.status = "Processed";
          }
          if (elem.status == STATUS_REJECTED) {
            elem.status = "Rejected";
          }
          if (elem.status == STATUS_APPROVED) {
            elem.status = "Approved";
          }
          if (elem.status == STATUS_PENDING_INVESTOR) {
            elem.status = "Pending Investor Approval";
          }
          if (elem.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
            elem.service_type_name = "New Loan";
          }
          if (elem.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
            elem.service_type_name = "Extend Tenure";
          }
          if (elem.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
            elem.service_type_name = "Pre Closure";
          }
          if (elem.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT) {
            elem.service_type_name = "Partial Pre-payment";
          }
        });
        setServiceData(res.data.data);
        setServiceDataFilter(res.data.data);
        setFourthValue(res.data.data);
        setFirstValue(res.data.data);
        setSecondValue(res.data.data);
        setThirdValue(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [initialValue, setInitialValue] = useState('')
  const [secondFilterValue, setSecondFilterValue] = useState('')
  const [thirdFilterValue, setThirdFilterValue] = useState('')
  const [fourthFilterValue, setFourthFilterValue] = useState('')

  const handleChangeInput = (e) => {
    let t_name = e.target.name;
    let t_value = e.target.value;
  
    if (t_name === "sRequstType" && thirdFilterValue === '' && secondFilterValue ==='' && fourthFilterValue ==='') {
      setInitialValue('sRequstType')
      let S_type = firstValue.filter((item) => {
        if (t_value === item.service_type_name) {
          return item;
        }
        if (t_value == "All") {
                setInitialValue('')
                return item;
              }
            });
            setServiceDataFilter(S_type);
            setSecondValue(S_type)
            setThirdValue(S_type)
            setFourthValue(S_type)
          }
    if (t_name === "sRequstType" && thirdFilterValue !== '' ) {
      let S_type = firstValue.filter((item) => {
              if (t_value === item.service_type_name) {
                return item;
              }
              if (t_value == "All") {
                return item;
              }
            });
            setServiceDataFilter(S_type);
            setSecondValue(S_type)
            setFourthValue(S_type)
          }  

    if (t_name === "sRequstStatus" && initialValue !=='' ) {
      let S_type = thirdValue.filter((item) => {
              if (t_value === item.status) {
                return item;
              }
              if (t_value == "All") {
                return item;
              }
            });
            setServiceDataFilter(S_type);
            setSecondValue(S_type)
            setFourthValue(S_type)
          }

    if (t_name === "sRequstStatus" && initialValue ==='' && secondFilterValue ==='' && fourthFilterValue ==='') {
      setThirdFilterValue('sRequstStatus')
      let S_type = thirdValue.filter((item) => {
        if (t_value === item.status) {
          return item;
        }
        if (t_value == "All") {
                setThirdFilterValue('')
                return item;
              }
            });
            setServiceDataFilter(S_type);
            setSecondValue(S_type)
            setFirstValue(S_type)
            setFourthValue(S_type)
          }

    if (t_name === "sRefNo" && initialValue ==='' && thirdFilterValue ==='' && fourthFilterValue ==='') {
      setSecondFilterValue('sRefNo')
      let S_type = secondValue.filter((item) => {
        if (t_value === item.service_request_reference_no) {
          return item;
        }
        if (t_value == "All") {
                setSecondFilterValue('')
                return item;
              }
            });
            setServiceDataFilter(S_type);
            setFourthValue(S_type)
            setFirstValue(S_type)
            setThirdValue(S_type)
          }

    if (t_name === "sRefNo" && initialValue !=='') {
      setSecondFilterValue("sRefNo")
      let S_type = secondValue.filter((item) => {
        if (t_value === item.service_request_reference_no) {
          return item;
        }
        if (t_value == "All") {
                setSecondFilterValue("")
                return item;
              }
            });
            setServiceDataFilter(S_type);
            setFourthValue(S_type)
            setThirdValue(S_type)
          }


    if (t_name === "sRefNo" && thirdFilterValue !=='' ) {
      let S_type = secondValue.filter((item) => {
              if (t_value === item.service_request_reference_no) {
                return item;
              }
              if (t_value == "All") {
                return item;
              }
            });
            setServiceDataFilter(S_type);
            setFourthValue(S_type)
            setFirstValue(S_type)
          }

    if (t_name === "sRefNo" && fourthFilterValue !=='') {
      let S_type = secondValue.filter((item) => {
              if (t_value === item.service_request_reference_no) {
                return item;
              }
              if (t_value == "All") {
                return item;
              }
            });
            setServiceDataFilter(S_type);
            setFirstValue(S_type)
            setThirdValue(S_type)
          }
    if (t_name === "sRefNo" && initialValue !=='' && fourthFilterValue !== '') {
      let S_type = secondValue.filter((item) => {
              if (t_value === item.service_request_reference_no) {
                return item;
              }
              if (t_value == "All") {
                return item;
              }
            });
            setServiceDataFilter(S_type);
            setThirdValue(S_type)
          }



    if (t_name === "lRefNo" && initialValue ==='' && thirdFilterValue ==='' && secondFilterValue ==='') {
      setFourthFilterValue('lRefNo')
      let S_type = fourthValue.filter((item) => {
        if (t_value === item.loan_reference_number) {
          return item;
        }
        if (t_value == "All") {
                setFourthFilterValue('')
                return item;
              }
            });
            setServiceDataFilter(S_type);
            setSecondValue(S_type)
            setFirstValue(S_type)
            setThirdValue(S_type)
          }
    if (t_name === "lRefNo" && thirdFilterValue !=='') {
      let S_type = fourthValue.filter((item) => {
              if (t_value === item.loan_reference_number) {
                return item;
              }
              if (t_value == "All") {
                return item;
              }
            });
            setServiceDataFilter(S_type);
            setSecondValue(S_type)
            setFirstValue(S_type)
          }
    if (t_name === "lRefNo" && initialValue !=='' ) {
      setFourthFilterValue("lRefNo")
      let S_type = fourthValue.filter((item) => {
        if (t_value === item.loan_reference_number) {
          return item;
        }
        if (t_value == "All") {
                setFourthFilterValue("")
                return item;
              }
            });
            setServiceDataFilter(S_type);
            setSecondValue(S_type)
            setThirdValue(S_type)
          }
    if (t_name === "lRefNo" && initialValue !=='' && secondFilterValue !=='') {
      let S_type = fourthValue.filter((item) => {
              if (t_value === item.loan_reference_number) {
                return item;
              }
              if (t_value == "All") {
                return item;
              }
            });
            setServiceDataFilter(S_type);
            setThirdFilterValue(S_type)
          }





    if (t_name === "sRequstType" && fourthFilterValue !=='' ) {
      let S_type = firstValue.filter((item) => {
              if (t_value === item.service_type_name) {
                return item;
              }
              if (t_value == "All") {
                return item;
              }
            });
            setServiceDataFilter(S_type);
            setSecondValue(S_type)
            setThirdValue(S_type)
          }

          if (t_name === "sRequstStatus" && fourthFilterValue !=='' ) {
            let S_type = thirdValue.filter((item) => {
                    if (t_value === item.status) {
                      return item;
                    }
                    if (t_value == "All") {
                      return item;
                    }
                  });
                  setServiceDataFilter(S_type);
                  setSecondValue(S_type)
                  setFirstValue(S_type)
                }
         
          

setDefaultValue(false)


  }


  
  const [count, setCount] = useState();
  const [defaultvalue, setDefaultValue] = useState(false);
  const clearFilters = () => {
    setServiceDataFilter(servicedata);
    setDefaultValue(true);
    setFirstValue(servicedata);
    setSecondValue(servicedata);
    setThirdValue(servicedata);
    setFourthValue(servicedata);
    setInitialValue('')
    setSecondFilterValue('')
    setThirdFilterValue('')
    setFourthFilterValue('')
  };
  const uniqueServiceTypes = [
    ...new Set(firstValue.map(service => {
      return service.service_type_name

    })),
  ];
  const uniqueStatuses = [
    ...new Set(thirdValue.map((service) => service.status)),
  ];
  const uniqueLoanRefNo = [
    ...new Set(fourthValue.map((service) => service.loan_reference_number)),
  ];
  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <SideNavBar />
      <main style={{ width: "100%" }}>
        <NavBarMain businessname={businessdataUser?.business_name} />
        <div className="content_main_body db_body">
          <div className="row d-flex flex-column ">
            <div className="col d-flex justify-content-between">
              <h1>My Service Requests</h1>
              <div className="col count_of_records pt-2">
                <span>No.of Records : {count}</span>
              </div>

              <button className="btn gray_btn" onClick={() => setShow(true)}>
                New Service Request
              </button>
              <NewServiceRequest show={show} onHide={() => setShow(false)} />
            </div>
            <div className="row d-flex gap-4 ">
              <div className="col-md">
                <label htmlFor="sRequstType">
                  <p>Service Request Type</p>
                </label>
                <select
                  id="sRequstType"
                  className="form-select  dropdn_select_cls shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="sRequstType"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option selected={defaultvalue}>All</option>
                  {uniqueServiceTypes.map((service, index) => {
                    return (
                      <option className="" key={index}>
                        {service}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-md">
                <label htmlFor="lRefNo">
                  <p>Loan Ref No.</p>
                </label>
                <select
                  id="lRefNo"
                  className="form-select  dropdn_select_cls shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="lRefNo"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option selected={defaultvalue}>All</option>
                  {uniqueLoanRefNo.map((service, index) => {
                    return <option key={index}>{service}</option>;
                  })}
                </select>
              </div>
              <div className="col-md-2">
                <label htmlFor="sRefNo">
                  <p>Service Ref No.</p>
                </label>
                <select
                  id="sRefNo"
                  className="form-select  dropdn_select_cls shadow-ben APNL_option_flds "
                  aria-label="form-select example"
                  name="sRefNo"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option selected={defaultvalue}>All</option>
                  {secondValue.map((type, index) => {
                    return (
                      <option key={index}>
                        {type.service_request_reference_no}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-md">
                <label htmlFor="sRequstStatus">
                  <p>Status</p>
                </label>
                <select
                  id="sRequstStatus"
                  className="form-select  dropdn_select_cls shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="sRequstStatus"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option selected={defaultvalue}>All</option>
                  {uniqueStatuses.map((service, index) => {
                    return (
                      <option className="" key={index}>
                        {service}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col count_of_records ">
                <button className="blue_btn" onClick={clearFilters}>
                  Clear All Filters
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col mt-3 myservice_table_div">
              <Datatable
                setservicedatafilter={setServiceDataFilter}
                ltwo={ltwo}
                loading={loading}
                count={setCount}
                servicedatafilter={servicedatafilter}
              />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default MyServiceRequests;

const Datatable = ({
  servicedatafilter,
  refNo,
  count,
  ltwo,
  loading,
  setservicedatafilter,
}) => {
  const [show, setShow] = React.useState(false);
  count(servicedatafilter.length);
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });

  const [modalShow, setModalShow] = React.useState(false);
  const [selectedobject, setServiceObject] = useState([]);
  const [modalShowAwaiting, setModalShowAwaiting] = React.useState(false);
  const [selectedobjectAwaiting, setServiceObjectAwaiting] = useState([]);
  const SelectedObj = (data) => {
    setServiceObject(data);
    setModalShow(true);
  };

  const SelectedAwatingResponseObj = (data) => {
    setServiceObjectAwaiting(data);
    setModalShowAwaiting(true);
  };
  const headers = [
    { title: "Service Request Type", sort: "service_type_name" },
    { title: "Loan Ref No", sort: "loan_reference_number" },
    { title: "Service Ref No.", sort: "service_request_reference_no" },
    { title: "Created Date", sort: "created_date_time" },
    { title: "Status", sort: "status" },
    { title: "Actions" },
  ];
  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...servicedatafilter].sort((a, b) => {
      const columnA = a[column];
      const columnB = b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setservicedatafilter(sortedData);
  };
  return (
    <div className="inv_my_servicereq_table">
      <Table striped className=" ">
        <thead className="myloan_table_headers text-center">
          <tr>
            {headers.map((header, index) => (
              <th
                className="Cpointer"
                key={header.sort}
                onClick={() => handleSort(header.sort)}
              >
                {ltwo || loading ? (
                  <Skeleton width={100} height={15} />
                ) : header.title !== "Actions" ? (
                  <>
                    {" "}
                    {header.title}
                    &#9662;
                  </>
                ) : (
                  header.title
                )}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {servicedatafilter.map((service, index) => {
            return (
              <tr key={index}>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : (
                    service.service_type_name
                  )}
                </td>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : (
                    service.loan_reference_number
                  )}
                </td>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : (
                    service.service_request_reference_no
                  )}
                </td>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : (
                    moment(service.created_date_time).format("DD MMM YYYY")
                  )}
                </td>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : service.status === "In Progress" &&
                    service.is_investor_interested === 1 ? (
                    <div style={{ color: "green", fontWeight: 600 }}>Awaiting Your Response</div>
                  ) : service.status === "In Progress" ? (
                    <div style={{ color: "orange" }}>{service.status}</div>
                  ) : service.status === "Approved" ? (
                    <div style={{ color: "blue" }}>{service.status}</div>
                  ) : service.status === "Processed" ? (
                    <div style={{ color: "Green" }}>{service.status}</div>
                  ) : service.status === "Rejected" ? (
                    <div style={{ color: "red" }}>{service.status}</div>
                  ) : service.status === "Closed" ? (
                    <div style={{ color: "gray" }}>Closed</div>   
                  ) 
                  : service.status === 9 ? (
                    <div style={{ color: "gray" }}>Technical Closure</div>
                  )
                  : service.status === 8 ? (
                    <div style={{ color: "gray" }}>Delisted</div>
                  ) : (
                    service.status
                  )}
                </td>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : //  <img
                    //   className="indiv_loan_dtls_eye"
                    //   src="./images/eye.svg"
                    //   alt=""
                    // />
                    service.status == "In Progress" &&
                      service.is_investor_interested == 1 ? (
                      <img
                        onClick={() => SelectedAwatingResponseObj(service)}
                        className="indiv_loan_dtls_eye Cpointer"
                        src="./images/icons/blue_eye.svg"
                        alt=""
                      />
                    ) : service.status == "New" ? (
                      <img
                        onClick={() => SelectedObj(service)}
                        className="indiv_loan_dtls_eye Cpointer"
                        src="./images/icons/blue_eye.svg"
                        alt=""
                      />
                    ) : (
                      <img
                        className="indiv_loan_dtls_eye"
                        src="./images/eye.svg"
                        alt=""
                      />
                    )}{" "}
                </td>
              </tr>
            );
          })}

          <NewServiceRequest show={show} onHide={() => setShow(false)} />
          <ServiceRequestsDetails
            data={selectedobject}
            show={modalShow}
            onHide={() => setModalShow(false)}
          />
          <ServiceRequestsTerms
            data={selectedobjectAwaiting}
            show={modalShowAwaiting}
            onHide={() => setModalShowAwaiting(false)}
          />
        </tbody>
      </Table>
    </div>
  );
};
